/**
 * Entity types that support real-time notifications
 */
export type EntityChannelType = "observation" | "direct_work";

/**
 * Channel name generators
 */
export const channels = {
  user: (userId: number) => `users/${userId}`,
  orga: (orgaId: number) => `organisations/${orgaId}`,
  owner: (ownerId: number) => `owner/${ownerId}`,
  manager: (orgaId: number) => `/orga/${orgaId}/managers/`,
  familyGroup: (groupId: number) => `familygroups/${groupId}`,

  /**
   * Entity-specific channels for conflict detection
   * Used when multiple users might edit the same document simultaneously
   * @param type - Entity type (observation, direct_work)
   * @param id - Entity ID
   * @returns Channel name in format: entity:{type}:{id}
   */
  entity: (type: EntityChannelType, id: number) => `entity:${type}:${id}`,
} as const;
